import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["willChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { initPrefersReducedMotion } from '../utils/reduced-motion/index.mjs';
import { hasReducedMotionListener, prefersReducedMotion } from '../utils/reduced-motion/state.mjs';
import { SubscriptionManager } from '../utils/subscription-manager.mjs';
import { motionValue } from '../value/index.mjs';
import { isMotionValue } from '../value/utils/is-motion-value.mjs';
import { transformProps } from './html/utils/transform.mjs';
import { isControllingVariants, isVariantNode } from './utils/is-controlling-variants.mjs';
import { isVariantLabel } from './utils/is-variant-label.mjs';
import { updateMotionValuesFromProps } from './utils/motion-values.mjs';
import { resolveVariantFromProps } from './utils/resolve-variants.mjs';
import { warnOnce } from '../utils/warn-once.mjs';
import { featureDefinitions } from '../motion/features/definitions.mjs';
import { variantProps } from './utils/variant-props.mjs';
import { visualElementStore } from './store.mjs';
import { KeyframeResolver } from './utils/KeyframesResolver.mjs';
import { isNumericalString } from '../utils/is-numerical-string.mjs';
import { isZeroValueString } from '../utils/is-zero-value-string.mjs';
import { findValueType } from './dom/value-types/find.mjs';
import { complex } from '../value/types/complex/index.mjs';
import { getAnimatableNone } from './dom/value-types/animatable-none.mjs';
import { createBox } from '../projection/geometry/models.mjs';
import { frame, cancelFrame } from '../frameloop/frame.mjs';
var propEventHandlers = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
var numVariantProps = variantProps.length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
var VisualElement = /*#__PURE__*/function () {
  function VisualElement(_ref) {
    var _this = this;
    var parent = _ref.parent,
      props = _ref.props,
      presenceContext = _ref.presenceContext,
      reducedMotionConfig = _ref.reducedMotionConfig,
      blockInitialAnimation = _ref.blockInitialAnimation,
      visualState = _ref.visualState;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, VisualElement);
    /**
     * If true, will-change will be applied to the element. Only HTMLVisualElements
     * currently support this.
     */
    this.applyWillChange = false;
    /**
     * A reference to the current underlying Instance, e.g. a HTMLElement
     * or Three.Mesh etc.
     */
    this.current = null;
    /**
     * A set containing references to this VisualElement's children.
     */
    this.children = new Set();
    /**
     * Determine what role this visual element should take in the variant tree.
     */
    this.isVariantNode = false;
    this.isControllingVariants = false;
    /**
     * Decides whether this VisualElement should animate in reduced motion
     * mode.
     *
     * TODO: This is currently set on every individual VisualElement but feels
     * like it could be set globally.
     */
    this.shouldReduceMotion = null;
    /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */
    this.values = new Map();
    this.KeyframeResolver = KeyframeResolver;
    /**
     * Cleanup functions for active features (hover/tap/exit etc)
     */
    this.features = {};
    /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */
    this.valueSubscriptions = new Map();
    /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */
    this.prevMotionValues = {};
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    /**
     * An object containing an unsubscribe function for each prop event subscription.
     * For example, every "Update" event can have multiple subscribers via
     * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
     */
    this.propEventSubscriptions = {};
    this.notifyUpdate = function () {
      return _this.notify("Update", _this.latestValues);
    };
    this.render = function () {
      _this.isRenderScheduled = false;
      if (!_this.current) return;
      _this.triggerBuild();
      _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
    };
    this.isRenderScheduled = false;
    this.scheduleRender = function () {
      if (!_this.isRenderScheduled) {
        _this.isRenderScheduled = true;
        frame.render(_this.render, false, true);
      }
    };
    var latestValues = visualState.latestValues,
      renderState = visualState.renderState;
    this.latestValues = latestValues;
    this.baseTarget = _objectSpread({}, latestValues);
    this.initialValues = props.initial ? _objectSpread({}, latestValues) : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't necessarily a breaking change,
     * more a reflection of the test.
     */
    var _this$scrapeMotionVal = this.scrapeMotionValuesFromProps(props, {}, this),
      willChange = _this$scrapeMotionVal.willChange,
      initialMotionValues = _objectWithoutProperties(_this$scrapeMotionVal, _excluded);
    for (var key in initialMotionValues) {
      var value = initialMotionValues[key];
      if (latestValues[key] !== undefined && isMotionValue(value)) {
        value.set(latestValues[key], false);
      }
    }
  }
  return _createClass(VisualElement, [{
    key: "scrapeMotionValuesFromProps",
    value:
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
      return {};
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      var _this2 = this;
      this.current = instance;
      visualElementStore.set(instance, this);
      if (this.projection && !this.projection.instance) {
        this.projection.mount(instance);
      }
      if (this.parent && this.isVariantNode && !this.isControllingVariants) {
        this.removeFromVariantTree = this.parent.addVariantChild(this);
      }
      this.values.forEach(function (value, key) {
        return _this2.bindToMotionValue(key, value);
      });
      if (!hasReducedMotionListener.current) {
        initPrefersReducedMotion();
      }
      this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
      if (process.env.NODE_ENV !== "production") {
        warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
      }
      if (this.parent) this.parent.children.add(this);
      this.update(this.props, this.presenceContext);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      visualElementStore.delete(this.current);
      this.projection && this.projection.unmount();
      cancelFrame(this.notifyUpdate);
      cancelFrame(this.render);
      this.valueSubscriptions.forEach(function (remove) {
        return remove();
      });
      this.valueSubscriptions.clear();
      this.removeFromVariantTree && this.removeFromVariantTree();
      this.parent && this.parent.children.delete(this);
      for (var key in this.events) {
        this.events[key].clear();
      }
      for (var _key in this.features) {
        var feature = this.features[_key];
        if (feature) {
          feature.unmount();
          feature.isMounted = false;
        }
      }
      this.current = null;
    }
  }, {
    key: "bindToMotionValue",
    value: function bindToMotionValue(key, value) {
      var _this3 = this;
      if (this.valueSubscriptions.has(key)) {
        this.valueSubscriptions.get(key)();
      }
      var valueIsTransform = transformProps.has(key);
      var removeOnChange = value.on("change", function (latestValue) {
        _this3.latestValues[key] = latestValue;
        _this3.props.onUpdate && frame.preRender(_this3.notifyUpdate);
        if (valueIsTransform && _this3.projection) {
          _this3.projection.isTransformDirty = true;
        }
      });
      var removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
      var removeSyncCheck;
      if (window.MotionCheckAppearSync) {
        removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
      }
      this.valueSubscriptions.set(key, function () {
        removeOnChange();
        removeOnRenderRequest();
        if (removeSyncCheck) removeSyncCheck();
        if (value.owner) value.stop();
      });
    }
  }, {
    key: "sortNodePosition",
    value: function sortNodePosition(other) {
      /**
       * If these nodes aren't even of the same type we can't compare their depth.
       */
      if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
        return 0;
      }
      return this.sortInstanceNodePosition(this.current, other.current);
    }
  }, {
    key: "updateFeatures",
    value: function updateFeatures() {
      var key = "animation";
      for (key in featureDefinitions) {
        var featureDefinition = featureDefinitions[key];
        if (!featureDefinition) continue;
        var isEnabled = featureDefinition.isEnabled,
          FeatureConstructor = featureDefinition.Feature;
        /**
         * If this feature is enabled but not active, make a new instance.
         */
        if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) {
          this.features[key] = new FeatureConstructor(this);
        }
        /**
         * If we have a feature, mount or update it.
         */
        if (this.features[key]) {
          var feature = this.features[key];
          if (feature.isMounted) {
            feature.update();
          } else {
            feature.mount();
            feature.isMounted = true;
          }
        }
      }
    }
  }, {
    key: "triggerBuild",
    value: function triggerBuild() {
      this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
  }, {
    key: "measureViewportBox",
    value: function measureViewportBox() {
      return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
    }
  }, {
    key: "getStaticValue",
    value: function getStaticValue(key) {
      return this.latestValues[key];
    }
  }, {
    key: "setStaticValue",
    value: function setStaticValue(key, value) {
      this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
  }, {
    key: "update",
    value: function update(props, presenceContext) {
      if (props.transformTemplate || this.props.transformTemplate) {
        this.scheduleRender();
      }
      this.prevProps = this.props;
      this.props = props;
      this.prevPresenceContext = this.presenceContext;
      this.presenceContext = presenceContext;
      /**
       * Update prop event handlers ie onAnimationStart, onAnimationComplete
       */
      for (var i = 0; i < propEventHandlers.length; i++) {
        var key = propEventHandlers[i];
        if (this.propEventSubscriptions[key]) {
          this.propEventSubscriptions[key]();
          delete this.propEventSubscriptions[key];
        }
        var listenerName = "on" + key;
        var listener = props[listenerName];
        if (listener) {
          this.propEventSubscriptions[key] = this.on(key, listener);
        }
      }
      this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
      if (this.handleChildMotionValue) {
        this.handleChildMotionValue();
      }
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
  }, {
    key: "getVariant",
    value: function getVariant(name) {
      return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */
  }, {
    key: "getDefaultTransition",
    value: function getDefaultTransition() {
      return this.props.transition;
    }
  }, {
    key: "getTransformPagePoint",
    value: function getTransformPagePoint() {
      return this.props.transformPagePoint;
    }
  }, {
    key: "getClosestVariantNode",
    value: function getClosestVariantNode() {
      return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
  }, {
    key: "getVariantContext",
    value: function getVariantContext() {
      var startAtParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (startAtParent) {
        return this.parent ? this.parent.getVariantContext() : undefined;
      }
      if (!this.isControllingVariants) {
        var _context = this.parent ? this.parent.getVariantContext() || {} : {};
        if (this.props.initial !== undefined) {
          _context.initial = this.props.initial;
        }
        return _context;
      }
      var context = {};
      for (var i = 0; i < numVariantProps; i++) {
        var name = variantProps[i];
        var prop = this.props[name];
        if (isVariantLabel(prop) || prop === false) {
          context[name] = prop;
        }
      }
      return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
  }, {
    key: "addVariantChild",
    value: function addVariantChild(child) {
      var closestVariantNode = this.getClosestVariantNode();
      if (closestVariantNode) {
        closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
        return function () {
          return closestVariantNode.variantChildren.delete(child);
        };
      }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
  }, {
    key: "addValue",
    value: function addValue(key, value) {
      // Remove existing value if it exists
      var existingValue = this.values.get(key);
      if (value !== existingValue) {
        if (existingValue) this.removeValue(key);
        this.bindToMotionValue(key, value);
        this.values.set(key, value);
        this.latestValues[key] = value.get();
      }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      this.values.delete(key);
      var unsubscribe = this.valueSubscriptions.get(key);
      if (unsubscribe) {
        unsubscribe();
        this.valueSubscriptions.delete(key);
      }
      delete this.latestValues[key];
      this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
  }, {
    key: "hasValue",
    value: function hasValue(key) {
      return this.values.has(key);
    }
  }, {
    key: "getValue",
    value: function getValue(key, defaultValue) {
      if (this.props.values && this.props.values[key]) {
        return this.props.values[key];
      }
      var value = this.values.get(key);
      if (value === undefined && defaultValue !== undefined) {
        value = motionValue(defaultValue === null ? undefined : defaultValue, {
          owner: this
        });
        this.addValue(key, value);
      }
      return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
  }, {
    key: "readValue",
    value: function readValue(key, target) {
      var _a;
      var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
      if (value !== undefined && value !== null) {
        if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
          // If this is a number read as a string, ie "0" or "200", convert it to a number
          value = parseFloat(value);
        } else if (!findValueType(value) && complex.test(target)) {
          value = getAnimatableNone(key, target);
        }
        this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
      }
      return isMotionValue(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
  }, {
    key: "setBaseTarget",
    value: function setBaseTarget(key, value) {
      this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
  }, {
    key: "getBaseTarget",
    value: function getBaseTarget(key) {
      var _a;
      var initial = this.props.initial;
      var valueFromInitial;
      if (typeof initial === "string" || typeof initial === "object") {
        var variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
        if (variant) {
          valueFromInitial = variant[key];
        }
      }
      /**
       * If this value still exists in the current initial variant, read that.
       */
      if (initial && valueFromInitial !== undefined) {
        return valueFromInitial;
      }
      /**
       * Alternatively, if this VisualElement config has defined a getBaseTarget
       * so we can read the value from an alternative source, try that.
       */
      var target = this.getBaseTargetFromProps(this.props, key);
      if (target !== undefined && !isMotionValue(target)) return target;
      /**
       * If the value was initially defined on initial, but it doesn't any more,
       * return undefined. Otherwise return the value as initially read from the DOM.
       */
      return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = new SubscriptionManager();
      }
      return this.events[eventName].add(callback);
    }
  }, {
    key: "notify",
    value: function notify(eventName) {
      if (this.events[eventName]) {
        var _this$events$eventNam;
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_this$events$eventNam = this.events[eventName]).notify.apply(_this$events$eventNam, args);
      }
    }
  }]);
}();
export { VisualElement };